(function(){
  const CART_ITEM_LINK_SELECTOR = 'a.cart-item__name, a.cart-item__link, .cart-item__name a, .wt-cart__item__thumb a.wt-cart__item__link, h2.wt-cart__item__name a.wt-cart__item__link'

  function removeConfigureButtons(root){
    try {
      const scope = root || document
      scope.querySelectorAll('.dpo_cart_edit_container, .dpo_cart_edit').forEach(el => {
        // Remove entire container if possible; otherwise hide the button
        if (el.classList.contains('dpo_cart_edit_container')) {
          el.remove()
        } else if (el.classList.contains('dpo_cart_edit')) {
          const cont = el.closest('.dpo_cart_edit_container')
          if (cont) cont.remove(); else el.remove()
        }
      })
    } catch(e){ console.warn('visualizer.cart: failed to remove Configure buttons', e) }
  }

  function observeConfigureButtons(){
    try {
      const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
          // Check added nodes
          m.addedNodes && m.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return
            if (node.matches && (node.matches('.dpo_cart_edit_container') || node.matches('.dpo_cart_edit'))) {
              removeConfigureButtons(node)
              return
            }
            // Also scan inside the subtree
            const found = node.querySelectorAll ? node.querySelectorAll('.dpo_cart_edit_container, .dpo_cart_edit') : []
            if (found && found.length) removeConfigureButtons(node)
          })
        }
      })
      mo.observe(document.body, { childList: true, subtree: true })
    } catch(e){ console.warn('visualizer.cart: observer error', e) }
  }

  function init(){
    if (!/\/cart(\?|$|\/?$)/.test(location.pathname)) return
    try {
      // Remove Configure button immediately and keep removing on future injections
      removeConfigureButtons(document)
      observeConfigureButtons()

      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => applyLinks(cart))
        .catch(err => console.warn('visualizer.cart: failed to load /cart.js', err))
    } catch(e){ console.warn('visualizer.cart: init error', e) }
  }

  function applyLinks(cart){
    const rows = Array.from(document.querySelectorAll('table.cart-items tr.cart-item, li.cart-item'))
    cart.items.forEach((item, idx) => {
      const row = rows[idx]
      if (!row) return

      const link = row.querySelector(CART_ITEM_LINK_SELECTOR)
      if (!link) return

      const props = item.properties || {}
      // If DPO provided a direct configuration link property, use it as-is
      const directLink = props['Configuration link'] || props['Configuration Link'] || props['configuration link']
      if (directLink) {
        const finalUrl = String(directLink)
        row.querySelectorAll(CART_ITEM_LINK_SELECTOR).forEach(a => a.setAttribute('href', finalUrl))
        return
      }

      const url = new URL(link.getAttribute('href') || (item.url || item.product_url || item.handle ? ('/products/' + (item.handle || '') ) : '/'), location.origin)

      // Ensure correct variant
      if (item.variant_id) url.searchParams.set('variant', item.variant_id)

      // Append visualizer params if present
      const raw = props._viz_params || props['[_viz_params]'] || props['_viz_params']
      if (raw) {
        try {
          // Accept querystring or JSON object string
          if (typeof raw === 'string' && raw.trim().startsWith('{')) {
            const obj = JSON.parse(raw)
            Object.entries(obj).forEach(([k, v]) => {
              if (!k) return
              const val = Array.isArray(v) ? v.join(',') : v
              if (val !== undefined && val !== null && val !== '') url.searchParams.set(k, val)
            })
          } else {
            const params = new URLSearchParams(String(raw))
            for (const [k, v] of params.entries()) {
              if (!k) continue
              if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, v)
            }
          }
        } catch(err) {
          console.warn('visualizer.cart: failed to parse _viz_params', err)
        }
      }

      const finalUrl = url.toString()
      row.querySelectorAll(CART_ITEM_LINK_SELECTOR).forEach(a => a.setAttribute('href', finalUrl))
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
